import { api } from "../http/apiClient";

const ApiLab = () => {
  const getFinishedPlannings = (params) => {
    return api.get(`/lab/plans/`, {
      params: params,
    });
  };

  const compare = (data) => {
    return api.post(`/lab/compare/`, data);
  };

  const getPlanDataForLab = (planId, labId) => {
    return api.get(`/lab/${labId}/plan/${planId}/`);
  };

  const updateLabPlan = (planId, labId, data) => {
    return api.patch(`/lab/${labId}/plan/${planId}/`, data);
  };

  const createNewPlanningFromLab = (labId, data) => {
    return api.post(`/lab/${labId}/finalize/`, data);
  }

  return {
    getFinishedPlannings,
    compare,
    getPlanDataForLab,
    updateLabPlan,
    createNewPlanningFromLab,
  };
};

export default ApiLab;
